module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dev', [_c('div', {
    staticClass: "simple-card",
    staticStyle: {
      "background-color": "#F8F8F8"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "2"
    }
  }, [_c('h3', {
    staticClass: "simple-card-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.leaderboard")) + "\n        "), (_vm.showInfo) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showInfoModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "font-size": "20px"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.progress < 75) ? _c('span', {
    staticClass: "simple-card-content"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.completeMoreQuizes")))]) : _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.joinedLeaderboard")))]), _vm._v(" "), (_vm.progress < 75) ? _c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    staticClass: "progress-eighty"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress",
    style: ('background-color: #0073B7; width:' + _vm.progress + '%')
  })]) : _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.improveRating")))])])]), _vm._v(" "), (_vm.showInfoModalBoolean) ? _c('div', {
    staticClass: "modal modal-success fade",
    attrs: {
      "id": _vm.modalInfoKey
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.infoTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.info')) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.infoDeviation')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ff10c00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ff10c00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/cards/LeaderboardAccuracyCard.vue
// module id = 1446
// module chunks = 1